import type { ReactNode } from 'react';

import { cn } from '@/lib/shadcn/utils';

interface SignupFlowShellProps {
  children: ReactNode;
  /** Widens the column for steps that show a side-by-side preview. */
  wide?: boolean;
  /** Rendered at the right edge of the top bar (the Log out button). */
  headerRight?: ReactNode;
}

/**
 * Signup frame: the portal token block (`.portal` in `index.css`) applied on
 * a wrapper, a slim top bar, and one centred column. The column's max-width
 * eases when a step needs the wide layout; it is a layout animation, accepted
 * because it runs once per signup.
 */
export const SignupFlowShell = ({
  children,
  wide = false,
  headerRight,
}: SignupFlowShellProps) => (
  <div className="portal bg-background text-foreground flex min-h-svh flex-col">
    <header className="bg-background flex h-12 shrink-0 items-center justify-between border-b px-4 md:px-6">
      <img src="/logo.png" alt="Finlay" className="h-6 w-auto object-contain" />
      {headerRight}
    </header>
    <main className="flex-1 overflow-y-auto">
      <div
        className={cn(
          'mx-auto w-full px-4 pt-10 pb-24 transition-[max-width] duration-300 ease-[cubic-bezier(0.23,1,0.32,1)] motion-reduce:transition-none md:px-6',
          wide ? 'max-w-[760px]' : 'max-w-[560px]',
        )}
      >
        {children}
      </div>
    </main>
  </div>
);
